const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/auth/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { toSafeRedirectPath } from '@/utils/safe-redirect';
export const Route = createFileRoute('/auth/login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: search => {
    const result: {
      redirect?: string;
      email?: string;
    } = {};
    const redirect = toSafeRedirectPath(search.redirect);
    if (redirect) {
      result.redirect = redirect;
    }
    if (typeof search.email === 'string') {
      result.email = search.email;
    }
    return result;
  }
});
export function TSRDummyComponent() {
  return null;
}